(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-acceso-prioritario-gracias"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('az-priority-thanks')) {
    const madridParts = (ts) => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Madrid',
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).formatToParts(new Date(ts));
      const get = (type) => Number(parts.find((p) => p.type === type).value);
      return { y: get('year'), m: get('month'), d: get('day'), h: get('hour'), min: get('minute') };
    };
    /* «2026-11-26 00:01» en hora de Madrid → milisegundos */
    const parseMadrid = (value) => {
      const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/.exec((value || '').trim());
      if (!m) return null;
      const asUtc = Date.UTC(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
      const p = madridParts(asUtc);
      return asUtc - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.min) - asUtc);
    };
    const madridDay = (ts) => {
      const p = madridParts(ts);
      return Date.UTC(p.y, p.m - 1, p.d) / 86400000;
    };
    const ymd = (ts, plusDays = 0) => {
      const p = madridParts(ts);
      const date = new Date(Date.UTC(p.y, p.m - 1, p.d + plusDays));
      return date.toISOString().slice(0, 10).replace(/-/g, '');
    };

    class AzPriorityThanks extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.times = { ea: parseMadrid(d.eaStart), bf: parseMadrid(d.bfStart), end: parseMadrid(d.end) };
        this.update();
        this.calendarLinks();
      }

      now() {
        const param = new URLSearchParams(location.search).get('az_now');
        return (param && parseMadrid(param)) || Date.now();
      }

      update() {
        const now = this.now();
        const t = this.times;
        let state = 'signup';
        if (t.ea && now >= t.ea) state = 'open';
        if (t.bf && now >= t.bf) state = 'sale';
        if (t.end && now >= t.end) state = 'after';

        this.querySelectorAll('[data-az-apt-state]').forEach((el) => {
          el.hidden = el.dataset.azAptState !== state;
        });
        this.querySelectorAll('[data-az-apt-before]').forEach((el) => {
          el.hidden = state !== 'signup';
        });

        const timer = this.querySelector('[data-az-apt-timer]');
        if (timer && t.ea) {
          const days = Math.max(0, madridDay(t.ea) - madridDay(now));
          const unit = days === 1 ? this.dataset.unitDay : this.dataset.unitDays;
          timer.hidden = days < 1;
          timer.querySelector('[data-az-apt-days]').textContent = days;
          timer.querySelector('[data-az-apt-unit]').textContent = unit;
          timer.querySelector('[data-az-apt-count]').textContent = `${days} ${unit}`;
        }
      }

      /* Evento de día completo el día que abre el Acceso Prioritario */
      calendarLinks() {
        const { ea } = this.times;
        if (!ea) return;
        const d = this.dataset;
        const start = ymd(ea);
        const end = ymd(ea, 1);
        const details = `${d.eventText}\n${d.eventUrl}`;

        const google = this.querySelector('[data-az-apt-google]');
        if (google) {
          const params = new URLSearchParams({ action: 'TEMPLATE', text: d.eventTitle, dates: `${start}/${end}`, details });
          google.href = `https://calendar.google.com/calendar/render?${params}`;
        }

        const ics = this.querySelector('[data-az-apt-ics]');
        if (ics) {
          const esc = (s) => s.replace(/\\/g, '\\\\').replace(/([,;])/g, '\\$1').replace(/\n/g, '\\n');
          const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
          const lines = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Tercio de las Torres//Acceso Prioritario//ES',
            'BEGIN:VEVENT',
            `UID:acceso-prioritario-${start}@terciodelastorres.com`,
            `DTSTAMP:${stamp}`,
            `DTSTART;VALUE=DATE:${start}`,
            `DTEND;VALUE=DATE:${end}`,
            `SUMMARY:${esc(d.eventTitle)}`,
            `DESCRIPTION:${esc(details)}`,
            `URL:${d.eventUrl}`,
            'BEGIN:VALARM',
            'ACTION:DISPLAY',
            `DESCRIPTION:${esc(d.eventTitle)}`,
            'TRIGGER:PT9H',
            'END:VALARM',
            'END:VEVENT',
            'END:VCALENDAR',
          ];
          ics.href = `data:text/calendar;charset=utf-8,${encodeURIComponent(lines.join('\r\n'))}`;
        }
      }
    }

    customElements.define('az-priority-thanks', AzPriorityThanks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-acceso-prioritario"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('az-priority-access')) {
    const MADRID = 'Europe/Madrid';
    const madridParts = (ts) => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: MADRID,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).formatToParts(new Date(ts));
      const get = (type) => Number(parts.find((p) => p.type === type).value);
      return { y: get('year'), m: get('month'), d: get('day'), h: get('hour'), min: get('minute') };
    };
    /* «2026-11-26 00:01» en hora de Madrid → milisegundos */
    const parseMadrid = (value) => {
      const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/.exec((value || '').trim());
      if (!m) return null;
      const asUtc = Date.UTC(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
      const p = madridParts(asUtc);
      const offset = Date.UTC(p.y, p.m - 1, p.d, p.h, p.min) - asUtc;
      return asUtc - offset;
    };
    const madridDay = (ts) => {
      const p = madridParts(ts);
      return Date.UTC(p.y, p.m - 1, p.d) / 86400000;
    };
    const money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
    const formatMoney = (cents) => money.format(cents / 100);

    class AzPriorityAccess extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.times = {
          ea: parseMadrid(d.eaStart),
          bf: parseMadrid(d.bfStart),
          bw: parseMadrid(d.bwStart),
          cm: parseMadrid(d.cmStart),
          end: parseMadrid(d.end),
        };
        this.pcts = { bf: +d.pctBf || 30, bw: +d.pctBw || 20, cm: +d.pctCm || 15 };
        this.redirectAfterSignup();
        this.update();
        this.timer = setInterval(() => this.update(), 30000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      now() {
        const param = new URLSearchParams(location.search).get('az_now');
        return (param && parseMadrid(param)) || Date.now();
      }

      /* Tras el alta, Shopify vuelve con ?customer_posted=true#<id del formulario> */
      redirectAfterSignup() {
        const url = this.dataset.thanksUrl;
        if (!url || !location.search.includes('customer_posted=true')) return;
        const id = location.hash.slice(1);
        if (id && this.querySelector(`[data-az-ap-form="${CSS.escape(id)}"]`)) location.replace(url);
      }

      state(now) {
        const t = this.times;
        if (!t.ea || now < t.ea) return { name: 'signup', until: t.ea };
        if (!t.bf || now < t.bf) return { name: 'open', until: t.bf };
        if (t.end && now >= t.end) return { name: 'after' };
        if (t.cm && now >= t.cm) return { name: 'sale', phase: 'cm', until: t.end };
        if (t.bw && now >= t.bw) return { name: 'sale', phase: 'bw', until: t.cm || t.end };
        return { name: 'sale', phase: 'bf', until: t.bw || t.cm || t.end };
      }

      update() {
        const now = this.now();
        const s = this.state(now);
        const visible = {
          before: s.name === 'signup' || s.name === 'open',
          sale: s.name === 'sale',
          active: s.name !== 'after',
          always: true,
        };

        this.querySelectorAll('[data-az-ap-state]').forEach((el) => {
          el.hidden = el.dataset.azApState !== s.name;
        });
        this.querySelectorAll('[data-az-ap-vis]').forEach((el) => {
          el.hidden = !visible[el.dataset.azApVis];
        });
        this.querySelectorAll('[data-az-ap-form-text]').forEach((el) => {
          el.hidden = el.dataset.azApFormText !== (s.name === 'open' ? 'open' : 'signup');
        });

        const pct = s.name === 'sale' ? this.pcts[s.phase] : this.pcts.bf;
        if (s.name === 'sale') this.showPhase(s.phase, pct);
        this.updatePrices(pct);

        const current = this.querySelector(`[data-az-ap-state="${s.name}"]`);
        const boxes = current && current.querySelector('[data-az-ap-boxes]');
        const text = current && current.querySelector('[data-az-ap-count]');
        if (boxes) {
          const parts = this.countdown(s, now);
          boxes.innerHTML = parts
            .map((p) => `<span class="az-ap__timer-box"><span class="az-ap__timer-num">${p.value}</span><span class="az-ap__timer-unit">${p.unit}</span></span>`)
            .join('');
          if (text) text.textContent = parts.map((p) => `${p.value} ${p.unit}`).join(' ');
        }
      }

      showPhase(phase, pct) {
        const label = this.querySelector('[data-az-ap-phase-name]');
        const name = this.dataset[`${phase}Name`];
        if (label && name) label.textContent = name;
        this.querySelectorAll('[data-az-ap-pct]').forEach((el) => {
          el.textContent = pct;
        });
      }

      updatePrices(pct) {
        this.querySelectorAll('[data-az-ap-product]').forEach((card) => {
          if (card.hasAttribute('data-live')) return;
          const base = +card.dataset.base;
          const litres = +card.dataset.litres;
          const sale = Math.round((base * (100 - pct)) / 100);
          const saleEl = card.querySelector('[data-az-ap-sale]');
          const saveEl = card.querySelector('[data-az-ap-save]');
          const pplEl = card.querySelector('[data-az-ap-ppl]');
          if (saleEl) saleEl.textContent = formatMoney(sale);
          if (saveEl) saveEl.textContent = formatMoney(base - sale);
          if (pplEl && litres > 0) pplEl.textContent = formatMoney(Math.round(sale / litres));
        });
      }

      /* Antes de abrir, solo días; desde que abre, días (si quedan), horas y minutos */
      countdown(s, now) {
        if (!s.until) return [];
        const u = this.dataset;
        const days = (n) => ({ value: n, unit: n === 1 ? u.unitDay : u.unitDays });
        if (s.name === 'signup') {
          const d = madridDay(s.until) - madridDay(now);
          if (d >= 1) return [days(d)];
        }
        const mins = Math.max(0, Math.ceil((s.until - now) / 60000));
        const d = Math.floor(mins / 1440);
        const h = Math.floor((mins % 1440) / 60);
        const parts = [
          { value: h, unit: h === 1 ? u.unitHour : u.unitHours },
          { value: String(mins % 60).padStart(2, '0'), unit: u.unitMinutes },
        ];
        return d > 0 ? [days(d), ...parts] : parts;
      }
    }

    customElements.define('az-priority-access', AzPriorityAccess);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-cart-main"]) return;
  try {
    
(function () {
  class AzCartCtrl extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick.bind(this));

      const toggle = this.querySelector('.az-cp__disc-toggle');
      const body   = this.querySelector('.az-cp__disc-body');
      if (toggle && body) {
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!open));
          body.hidden = open;
        });
      }
    }

    async #onClick(e) {
      const btn = e.target.closest('[data-action]');
      if (!btn || btn.disabled) return;

      const action = btn.dataset.action;

      if (action === 'dec' || action === 'inc' || action === 'rm') {
        const row = btn.closest('[data-key]');
        if (row) await this.#changeQty(row, action);
      }

      if (action === 'add') {
        await this.#addToCart(btn);
      }
    }

    async #changeQty(row, action) {
      const key    = row.dataset.key;
      const qtyEl  = row.querySelector('.az-cp__qty-n');
      const unit   = parseInt(row.dataset.unit || 0, 10);
      let qty      = parseInt(qtyEl?.textContent || '1', 10);

      if (action === 'inc') qty++;
      else if (action === 'dec') qty = Math.max(0, qty - 1);
      else qty = 0;

      row.setAttribute('data-loading', '');
      row.querySelectorAll('.az-cp__qty-btn, .az-cp__rm').forEach(b => { b.disabled = true; });

      try {
        const res  = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();

        if (qty === 0) {
          row.remove();
          if (cart.item_count === 0) { location.reload(); return; }
        } else {
          if (qtyEl) qtyEl.textContent = qty;
          const lineEl = row.querySelector('.az-cp__line-total');
          if (lineEl) lineEl.textContent = this.#money(unit * qty);
          const compareEl = row.querySelector('.az-cp__line-compare');
          if (compareEl) {
            const compareUnit = parseInt(row.dataset.compareUnit || 0, 10);
            compareEl.textContent = this.#money(compareUnit * qty);
          }
          row.removeAttribute('data-loading');
          row.querySelectorAll('.az-cp__qty-btn, .az-cp__rm').forEach(b => { b.disabled = false; });
        }

        this.#updateSummary(cart);
      } catch {
        row.removeAttribute('data-loading');
        row.querySelectorAll('.az-cp__qty-btn, .az-cp__rm').forEach(b => { b.disabled = false; });
      }
    }

    async #addToCart(btn) {
      const vid = btn.dataset.vid;
      if (!vid) return;
      const orig = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        });

        if (res.ok) {
          btn.dataset.added = '1';
          btn.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> ' + ((window.azT || {}).cartAdded || 'Añadido');
          setTimeout(() => location.reload(), 900);
        } else {
          btn.disabled = false;
          btn.innerHTML = orig;
        }
      } catch {
        btn.disabled = false;
        btn.innerHTML = orig;
      }
    }

    #updateSummary(cart) {
      const formatted = this.#money(cart.total_price);

      const sub    = this.querySelector('.az-cp__subtotal');
      const total  = this.querySelector('.az-cp__total-amt');
      const count  = this.querySelector('.az-cp__count');
      const mPrice = this.querySelector('.az-cp__cta-mobile-price');

      if (sub)    sub.textContent   = formatted;
      if (total)  total.textContent = formatted;
      if (mPrice) mPrice.textContent = formatted;
      if (count) {
        const n = cart.item_count;
        count.textContent = `${n} ${n === 1 ? ((window.azT || {}).cartItemOne || 'artículo') : ((window.azT || {}).cartItemOther || 'artículos')}`;
      }

      let compareTotal = 0;
      this.querySelectorAll('.az-cp__row').forEach((row) => {
        const unit        = parseInt(row.dataset.unit || 0, 10);
        const compareUnit = parseInt(row.dataset.compareUnit || 0, 10);
        const qty         = parseInt(row.querySelector('.az-cp__qty-n')?.textContent || 0, 10);
        const lineUnit    = compareUnit > unit ? compareUnit : unit;
        compareTotal += lineUnit * qty;
      });
      const savings = compareTotal - cart.total_price;

      const origRow = this.querySelector('.az-cp__original-row');
      const savRow  = this.querySelector('.az-cp__savings-row');
      const origAmt = this.querySelector('.az-cp__original-amt');
      const savAmt  = this.querySelector('.az-cp__savings-amt');

      if (savings > 0) {
        if (origAmt) origAmt.textContent = this.#money(compareTotal);
        if (savAmt)  savAmt.textContent  = '−' + this.#money(savings);
        if (origRow) origRow.hidden = false;
        if (savRow)  savRow.hidden  = false;
      } else {
        if (origRow) origRow.hidden = true;
        if (savRow)  savRow.hidden  = true;
      }
    }

    #money(cents) {
      return '€' + (cents / 100).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  if (!customElements.get('az-cart-ctrl')) {
    customElements.define('az-cart-ctrl', AzCartCtrl);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-header"] && !Shopify.designMode) return;
  try {
    
class AzHdrBar extends HTMLElement {
  #lastY = 0;

  #onScroll = () => {
    const y = window.scrollY;
    this.dataset.scrolled = y > 10 ? 'true' : 'false';
    if (y <= 0) {
      this.dataset.hidden = 'false';
    } else if (y > this.#lastY && y > 80) {
      this.dataset.hidden = 'true';
    } else if (y < this.#lastY) {
      this.dataset.hidden = 'false';
    }
    this.#lastY = y;
  };

  connectedCallback() {
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#onScroll();

    document.addEventListener('cart:updated', (e) => {
      const count = e.detail?.cart?.item_count ?? 0;
      this.#updateCartCount(count);
    });

    document.addEventListener('cart:add', () => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(c => this.#updateCartCount(c.item_count))
        .catch(() => {});
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }

  #updateCartCount(count) {
    const el = this.querySelector('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
    el.dataset.cartCount = count;
    el.classList.toggle('az-hdr__cart-count--hidden', count === 0);
    if (count > 0) {
      el.animate([{ transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 250, easing: 'ease-out' });
    }
  }
}
if (!customElements.get('az-hdr-bar')) customElements.define('az-hdr-bar', AzHdrBar);

// Drawer
(function () {
  const drawer = document.getElementById('az-nav-drawer');
  const burger = document.querySelector('.az-hdr__burger');
  const closeBtn = drawer?.querySelector('.az-nav-drawer__close');
  const overlay = drawer?.querySelector('.az-nav-drawer__overlay');
  if (!drawer || !burger) return;

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('az-drawer-open');
    closeBtn?.focus();
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('az-drawer-open');
    burger.focus();
  }

  burger.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a, button')].filter(el => !el.disabled);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-lead-guide"] && !Shopify.designMode) return;
  try {
    
class AzLeadGuidePopup extends HTMLElement {
  #dialog;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    if (!this.#dialog) return;

    this.#dialog.addEventListener('click', (event) => {
      if (event.target === this.#dialog) this.#dialog.close();
    });
    this.#dialog.addEventListener('close', () => document.documentElement.classList.remove('az-lgp-open'));

    for (const el of this.querySelectorAll('[data-az-lgp-close]')) {
      el.addEventListener('click', () => this.#dialog.close());
    }
    for (const el of this.querySelectorAll('[data-az-lgp-cta]')) {
      el.addEventListener('click', () => setTimeout(() => this.#dialog.close(), 300));
    }

    if (this.dataset.success === 'true') this.#cleanUrl();
    this.#open();
  }

  disconnectedCallback() {
    document.documentElement.classList.remove('az-lgp-open');
  }

  #open() {
    if (this.#dialog.open) return;
    for (const other of document.querySelectorAll('dialog[open]')) other.close();
    document.documentElement.classList.add('az-lgp-open');
    this.#dialog.showModal();
  }

  // Quita ?customer_posted=true para que recargar la página no vuelva a abrir el pop-up.
  #cleanUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('customer_posted')) return;
    url.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }
}

if (!customElements.get('az-lead-guide-popup')) customElements.define('az-lead-guide-popup', AzLeadGuidePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-lead-magnets"] && !Shopify.designMode) return;
  try {
    
class AzLeadMagnets extends HTMLElement {
  #dialog;

  connectedCallback() {
    for (const link of this.querySelectorAll('[data-az-lm-jump]')) {
      link.addEventListener('click', this.#jumpToForm);
    }

    this.#dialog = this.querySelector('.az-lmp');
    if (!this.#dialog) return;

    this.#dialog.addEventListener('click', (event) => {
      if (event.target === this.#dialog) this.#dialog.close();
    });
    this.#dialog.addEventListener('close', () => document.documentElement.classList.remove('az-lmp-open'));

    for (const el of this.querySelectorAll('[data-az-lmp-close]')) {
      el.addEventListener('click', () => this.#dialog.close());
    }

    this.#open();
    if (this.#dialog.dataset.success === 'true') this.#cleanUrl();
  }

  disconnectedCallback() {
    document.documentElement.classList.remove('az-lmp-open');
  }

  // Los botones de cada recetario llevan al formulario y dejan el cursor en el primer campo.
  #jumpToForm = (event) => {
    const field = this.querySelector('.az-lm__input');
    if (!field) return;
    event.preventDefault();
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    field.form.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    field.focus({ preventScroll: true });
  };

  #open() {
    if (this.#dialog.open) return;
    for (const other of document.querySelectorAll('dialog[open]')) other.close();
    document.documentElement.classList.add('az-lmp-open');
    this.#dialog.showModal();
  }

  // Quita ?customer_posted=true para que recargar la página no vuelva a abrir el pop-up.
  #cleanUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('customer_posted')) return;
    url.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', url.href);
  }
}

if (!customElements.get('az-lead-magnets')) customElements.define('az-lead-magnets', AzLeadMagnets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-pdp-razones"] && !Shopify.designMode) return;
  try {
    
class AzRazReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const leftItems = [...this.querySelectorAll('.az-pdp-raz__col--l .az-pdp-raz-item')];
    const rightItems = [...this.querySelectorAll('.az-pdp-raz__col--r .az-pdp-raz-item')];
    const imgWrap = this.querySelector('.az-pdp-raz__img');

    leftItems.forEach((el, i) => {
      el.style.setProperty('--az-raz-delay', `${i * 0.12}s`);
      el.classList.add('az-raz-pending-l');
    });
    rightItems.forEach((el, i) => {
      el.style.setProperty('--az-raz-delay', `${i * 0.12}s`);
      el.classList.add('az-raz-pending-r');
    });
    if (imgWrap) imgWrap.classList.add('az-raz-pending');

    const reveal = () => {
      leftItems.forEach(el => el.classList.remove('az-raz-pending-l'));
      rightItems.forEach(el => el.classList.remove('az-raz-pending-r'));
      if (imgWrap) imgWrap.classList.remove('az-raz-pending');
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { reveal(); observer.disconnect(); }
    }, { threshold: 0.1 });

    observer.observe(this);
  }
}
if (!customElements.get('az-raz-reveal')) {
  customElements.define('az-raz-reveal', AzRazReveal);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-promo-popup"] && !Shopify.designMode) return;
  try {
    
class AzPromoPopup extends HTMLElement {
  #dialog;
  #timer;
  #bannerWatch;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    if (!this.#dialog) return;

    this.#dialog.addEventListener('click', (event) => {
      if (event.target === this.#dialog) this.#close();
    });
    this.#dialog.addEventListener('cancel', () => this.#remember());
    this.#dialog.addEventListener('close', () => document.documentElement.classList.remove('az-promo-open'));

    for (const el of this.querySelectorAll('[data-az-promo-close]')) {
      el.addEventListener('click', () => this.#close());
    }
    for (const el of this.querySelectorAll('[data-az-promo-cta]')) {
      el.addEventListener('click', () => this.#remember());
    }

    if (this.dataset.designMode === 'true') {
      this.#bindEditor();
      return;
    }

    if (!this.#eligible()) return;
    const delay = Number(this.dataset.delay) || 0;
    this.#timer = setTimeout(() => this.#open(), delay * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    clearInterval(this.#bannerWatch);
  }

  #eligible() {
    const phase = document.documentElement.getAttribute('data-az-campaign');
    if (phase === 'over' || phase === 'upcoming') return false;
    if (phase === 'before' && this.dataset.showBefore !== 'true') return false;
    try {
      if (localStorage.getItem(this.dataset.key)) return false;
    } catch (error) {}
    return true;
  }

  async #open() {
    await this.#afterCookieBanner();
    if (this.#dialog.open || !this.#eligible()) return;
    if (document.querySelector('dialog[open]')) return;
    document.documentElement.classList.add('az-promo-open');
    this.#dialog.showModal();
  }

  #afterCookieBanner() {
    const visible = () => {
      const banner = document.getElementById('shopify-pc__banner');
      return Boolean(banner && banner.offsetHeight);
    };
    if (!visible()) return Promise.resolve();
    return new Promise((resolve) => {
      this.#bannerWatch = setInterval(() => {
        if (visible()) return;
        clearInterval(this.#bannerWatch);
        this.#timer = setTimeout(resolve, 1500);
      }, 500);
    });
  }

  #close() {
    this.#remember();
    this.#dialog.close();
  }

  #remember() {
    if (this.dataset.designMode === 'true') return;
    try {
      localStorage.setItem(this.dataset.key, String(Date.now()));
    } catch (error) {}
  }

  #bindEditor() {
    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId !== this.dataset.sectionId || this.#dialog.open) return;
      document.documentElement.classList.add('az-promo-open');
      this.#dialog.showModal();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) this.#dialog.close();
    });
  }
}

if (!customElements.get('az-promo-popup')) customElements.define('az-promo-popup', AzPromoPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-sticky-atc"] && !Shopify.designMode) return;
  try {
    
class AzSatcBar extends HTMLElement {
  #observer = null;
  #priceEl = null;
  #compareEl = null;
  #btnEl = null;

  connectedCallback() {
    this.#priceEl = this.querySelector('[data-az-satc-price]');
    this.#compareEl = this.querySelector('[data-az-satc-compare]');
    this.#btnEl = this.querySelector('.az-satc__btn');
    if (this.#btnEl) this.#btnEl.addEventListener('click', this.#handleClick);
    this.#setupObserver();
    this.#syncPrice();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#btnEl?.removeEventListener('click', this.#handleClick);
  }

  #setupObserver() {
    const buyBlock = document.querySelector('.az-mp-atc-row, .buy-buttons-block, [id^="AzForm-"]');
    if (!buyBlock) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting;
      this.dataset.visible = visible ? 'true' : 'false';
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }, { threshold: 0 });
    this.#observer.observe(buyBlock);
  }

  #syncPrice() {
    const pagePrice = document.querySelector('.az-mp-price, .price__actual .money, [data-price] .money, price-component .money');
    if (pagePrice && this.#priceEl) {
      this.#priceEl.textContent = pagePrice.textContent;
      new MutationObserver(() => {
        if (this.#priceEl) this.#priceEl.textContent = pagePrice.textContent;
      }).observe(pagePrice, { childList: true, subtree: true, characterData: true });
    }

    const pageCompare = document.querySelector('.az-mp-price-compare');
    if (pageCompare && this.#compareEl) {
      this.#compareEl.textContent = pageCompare.textContent;
      new MutationObserver(() => {
        if (this.#compareEl) this.#compareEl.textContent = pageCompare.textContent;
      }).observe(pageCompare, { childList: true, subtree: true, characterData: true });
    }
  }

  #handleClick = () => {
    const atcBtn = document.querySelector('.az-mp-btn-atc:not(:disabled), [ref="addToCartButton"]:not(:disabled), .product-form__submit:not(:disabled), [name="add"]:not(:disabled)');
    atcBtn?.click();
  };
}
if (!customElements.get('az-satc-bar')) {
  customElements.define('az-satc-bar', AzSatcBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-close-topbar]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-close-topbar');
      var bar = document.getElementById('az-topbar-' + id);
      if (bar) {
        bar.style.transition = 'height .25s ease, opacity .25s ease';
        bar.style.opacity = '0';
        bar.style.height = '0';
        setTimeout(function () { bar.remove(); }, 260);
        try { sessionStorage.setItem('topbar-closed-' + id, '1'); } catch (e) {}
      }
    });
  });

  document.querySelectorAll('.az-topbar').forEach(function (bar) {
    var id = bar.id.replace('az-topbar-', '');
    try {
      if (sessionStorage.getItem('topbar-closed-' + id)) {
        bar.remove();
      }
    } catch (e) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var T = window.azT || {};
  var TRUST_HTML = [
    '<div class="az-trust">',
      '<div class="az-trust__row">',
        '<div class="az-trust__item">',
          '<span class="az-trust__icon">',
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
          '</span>',
          '<span class="az-trust__label">' + (T.trustSsl || 'Pago<br>seguro SSL') + '</span>',
        '</div>',
        '<span class="az-trust__sep" aria-hidden="true"></span>',
        '<div class="az-trust__item">',
          '<span class="az-trust__icon">',
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
          '</span>',
          '<span class="az-trust__label">' + (T.trustShip || 'Entrega<br>2-3 días') + '</span>',
        '</div>',
        '<span class="az-trust__sep" aria-hidden="true"></span>',
        '<div class="az-trust__item">',
          '<span class="az-trust__icon">',
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.51"/></svg>',
          '</span>',
          '<span class="az-trust__label">' + (T.trustReturns || 'Devolución<br>30 días') + '</span>',
        '</div>',
      '</div>',
      '<div class="az-trust__pay">',
        '<span class="az-trust__card">VISA</span>',
        '<span class="az-trust__card">MC</span>',
        '<span class="az-trust__card">PayPal</span>',
        '<span class="az-trust__card">Bizum</span>',
      '</div>',
    '</div>'
  ].join('');

  function injectTrust() {
    /* Try to land inside the summary card; fall back to the wrapper */
    var target = document.querySelector('.cart-summary')
              || document.querySelector('.cart-summary__sticky')
              || document.querySelector('.cart-page__summary');
    if (!target || target.querySelector('.az-trust')) return;
    target.insertAdjacentHTML('beforeend', TRUST_HTML);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTrust);
  } else {
    injectTrust();
  }

  document.addEventListener('cart:updated', injectTrust);
  document.addEventListener('shopify:cart:updated', injectTrust);
  document.addEventListener('on:cart:change', injectTrust);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
